import { useSelector } from "react-redux";
const CryptoJS = require("crypto-js");
require("dotenv").config();

export const escapSpecialCharacter = (string) => {
  return string
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
};

export const encode = (myString) => {
  // PROCESS
  const encodedWord = CryptoJS.enc.Utf8.parse(myString); // encodedWord Array object
  const encoded = CryptoJS.enc.Base64.stringify(encodedWord); // string: 'NzUzMjI1NDE='
  return encoded;
};

export const decode = (encoded) => {
  // const encoded = "VGVzdEAxMjM0";
  // PROCES
  const encodedWord = CryptoJS.enc.Base64.parse(encoded); // encodedWord via Base64.parse()
  const decoded = CryptoJS.enc.Utf8.stringify(encodedWord); // decode encodedWord via Utf8.stringify() '75322541'
  return decoded;
};

export const setCacheData = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getCacheData = (key) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const getUserData = (encryptedUser) => {
  if (encryptedUser && Object.keys(encryptedUser).length === 0) return {};
  try {
    const bytes = CryptoJS.AES.decrypt(
      encryptedUser,
      process.env.REACT_APP_LOCAL_STORAGE_SECRET
    );
    let decrypted = bytes.toString(CryptoJS.enc.Utf8);
    if (decrypted.startsWith('"') && decrypted.endsWith('"')) {
      decrypted = decrypted.slice(1, -1);
    }
    decrypted = JSON.parse(decrypted);
    return decrypted;
    // return decrypted;
  } catch (err) {
    console.error("Error decrypting data", err);
    return null;
  }
};
